import { jsonRequest } from "@/helpers/wordpress";
import { EventCategory } from "@/domain/events/event-category";
import { AjaxResponse } from "@/domain/shared/wordpress/ajax-response";
import { Event } from "@/domain/events/event";

export interface FetchEventsOptions {
  category: EventCategory;
  page?: number;
  search?: string;
}

const fetchOptionsDefaults: FetchEventsOptions = {
  category: EventCategory.LATEST,
  page: 1,
  search: ''
}

async function getLatestEvents(options: FetchEventsOptions): Promise<AjaxResponse<Event>> {
  const response = await jsonRequest('GET', 'inc_events_latest', null, options);
  return await response.json();
}

async function getPastEvents(options: FetchEventsOptions): Promise<AjaxResponse<Event>> {
  const response = await jsonRequest('GET', 'inc_events_past', null, options);
  return await response.json();
}

async function getEventsByCategory(options: FetchEventsOptions): Promise<AjaxResponse<Event>> {
  const response = await jsonRequest('GET', 'inc_events_by_category', null, options);
  return await response.json();
}

export async function fetchEvents(options: FetchEventsOptions = fetchOptionsDefaults): Promise<AjaxResponse<Event>> {
  switch (options.category) {
    case EventCategory.LATEST:
      return await getLatestEvents(options);
    case EventCategory.PAST:
      return await getPastEvents(options);
    default:
      return await getEventsByCategory(options);
  }
}
